import React from 'react'
import styled from 'styled-components'

const CheckboxContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    user-select: none;
`

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
`

const StyledCheckbox = styled.div`
    display: inline-block;
    width: 18px;
    height: 18px;
    background: ${(props) => (props.checked ? '#007bff' : '#fff')};
    border: 1px solid ${(props) => (props.checked ? '#007bff' : '#ced4da')};
    border-radius: 3px;
    transition: all 150ms;
    position: relative;

    &:after {
        content: '';
        position: absolute;
        display: ${(props) => (props.checked ? 'block' : 'none')};
        left: 6px;
        top: 2px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
    }
`

const Checkbox = ({ checked, onChange, label, ...props }) => {
    return (
        <CheckboxContainer onClick={() => onChange(!checked)}>
            <HiddenCheckbox checked={checked} readOnly {...props} />
            <StyledCheckbox checked={checked} />
            {label && <span>{label}</span>}
        </CheckboxContainer>
    )
}

export default Checkbox
